// Ad-click IDs captured from the landing URL query. Read fresh on every request
// (not persisted) — the same values ride verify / beacon / probe. Adding a new
// platform's click id is a one-line change here, not three copies.
export interface AdClickIds {
  ttclid?: string;
  fbclid?: string;
  gclid?: string;
}

export function getAdClickIds(): AdClickIds {
  const params = new URLSearchParams(window.location.search);
  return {
    ttclid: params.get('ttclid') ?? undefined,
    fbclid: params.get('fbclid') ?? undefined,
    gclid: params.get('gclid') ?? undefined,
  };
}
